import React from 'react';
import i18next from 'i18next';
import { observer } from 'mobx-react';
import { Dropdown, Icon } from 'components';
import { DropDownItem, ViewTypeEnum } from 'types';
import { frameStore } from '../../appManager';
import {
  DropdownWrapper,
  dropItemStyle,
  dropTriggerStyle,
  placeholderStyle,
} from '../common';

const viewTypes = [ViewTypeEnum.Card, ViewTypeEnum.List].map(type => ({
  text: type,
  key: type,
  value: type,
}));

export const ViewToggle = observer(() => {
  const selectedItemIndex = viewTypes.findIndex(
    ({ value }) => value === frameStore.viewType,
  );

  return (
    <DropdownWrapper>
      <Dropdown
        dropItemStyle={dropItemStyle}
        size='small'
        dropTriggerStyle={dropTriggerStyle}
        placeholderStyle={placeholderStyle}
        items={viewTypes}
        trigger={
          <span
            className='inline-block mr-1'
            style={{
              color: '#777',
            }}
          >
            {i18next.t('View Type')}:
          </span>
        }
        iconRight={<Icon size='0.75em' name='caret_down' colorPath='#777' />}
        selectedItemIndex={selectedItemIndex}
        onItemSelected={({ value }: DropDownItem) => {
          frameStore.SetViewType(value);
        }}
      />
    </DropdownWrapper>
  );
});
